export default __webpack_public_path__ + "static/Ricettive-7a3a552dba921d3fcc8075ce90a28722.jpg";